import { ArrowRight, ScanLine, CircuitBoard, Gauge, Activity, Settings } from "lucide-react";
import { inverter, waLink, waMessages } from "@/content/siteContent";
import { Reveal } from "./Reveal";

const iconMap = { ScanLine, CircuitBoard, Gauge, Activity, Settings };

export default function Inverter() {
  return (
    <section id="inverter" className="honeycomb bg-ink py-24 md:py-32" data-testid="inverter-section">
      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-14 px-5 md:px-8 lg:grid-cols-2">
        <Reveal className="relative order-2 lg:order-1">
          <div className="stripes absolute -left-3 -top-3 h-24 w-24 rounded-tl-[20px] opacity-90" />
          <div className="relative overflow-hidden rounded-[20px] border border-metal" style={{ boxShadow: "var(--shadow-industrial)" }}>
            <img
              src={inverter.images.main}
              alt="Reparo de placa eletrônica inverter em bancada"
              loading="lazy"
              className="h-[320px] w-full object-cover md:h-[420px]"
              data-testid="inverter-main-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-8 -right-3 hidden w-44 overflow-hidden rounded-2xl border border-metal shadow-[0_18px_40px_-18px_rgba(0,0,0,0.8)] sm:block md:w-56">
            <img
              src={inverter.images.secondary}
              alt="Detalhe de circuito eletrônico"
              loading="lazy"
              className="h-32 w-full object-cover md:h-40"
              data-testid="inverter-secondary-image"
            />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <div className="mb-5 flex items-center gap-4">
              <span className="font-display text-xs font-extrabold tracking-[0.2em] text-steel">CAP. {inverter.chapter}</span>
              <span className="h-px w-10 bg-brand" />
              <p className="microtitle">{inverter.microtitle}</p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-paper sm:text-5xl lg:text-6xl" data-testid="inverter-title">
              {inverter.titleA}
              <br />
              <span className="text-brand">{inverter.highlightWord}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-mist">{inverter.description}</p>
          </Reveal>

          <div className="mt-9 grid gap-3 sm:grid-cols-2" data-testid="inverter-cards">
            {inverter.cards.map((card, i) => {
              const Icon = iconMap[card.icon];
              return (
                <Reveal key={card.title} delay={0.1 + i * 0.06}>
                  <div className={`card-industrial flex items-center gap-4 p-4 ${i === inverter.cards.length - 1 ? "sm:col-span-2" : ""}`} data-testid={`inverter-card-${card.title.toLowerCase().replace(/\s+/g, "-")}`}>
                    <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl border border-metal bg-ink">
                      <Icon className="h-5 w-5 text-brand" strokeWidth={1.8} />
                    </span>
                    <div>
                      <h3 className="font-display text-[0.72rem] font-extrabold tracking-[0.14em] text-paper">{card.title}</h3>
                      <p className="mt-0.5 text-xs text-mist/80">{card.desc}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.3}>
            <a
              href={waLink(waMessages.placas)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-industrial mt-10"
              data-testid="inverter-cta"
            >
              {inverter.cta}
              <ArrowRight className="h-4 w-4" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
